export const buildCognitoGoogleLoginUrl = (state?: string) => {
  const domain = process.env.REACT_APP_AWS_COGNITO_DOMAIN ?? "";
  const clientId = process.env.REACT_APP_AWS_COGNITO_CLIENT_ID ?? "";
  const redirectUri = process.env.REACT_APP_AWS_COGNITO_CALLBACK_URI ?? "";

  const params = [
    `client_id=${clientId}`,
    `response_type=code`,
    `scope=openid+email+phone`,
    `redirect_uri=${encodeURIComponent(redirectUri)}`,
    `identity_provider=Google`,
    `prompt=select_account`,
    `max_age=0`,
  ];

  // Cognito echoes `state` verbatim back to the callback, so we use it to carry
  // the post-login redirect target instead of stashing it in web storage.
  if (state) {
    params.push(`state=${encodeURIComponent(state)}`);
  }

  return `${domain}/oauth2/authorize?${params.join("&")}`;
};
